unit ClaimAmountReceivedForm;

interface

uses
  {$IFNDEF PAS2JS}
  Winapi.Windows, Winapi.Messages,
  {$ENDIF}
  System.SysUtils, {$IFNDEF PAS2JS}System.Variants,{$ENDIF} System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, WEBLib.Forms, WEBLib.Dialogs, WebForm.Core, Vcl.StdCtrls,
  WEBLib.StdCtrls, Data.DB, WEBLib.DB, WEBLib.DBCtrls;

type
  TAmountReceivedForm = class(TCoreWebForm)
    SaveButton: TButton;
    CancelButton: TButton;
    AmountEdit: TDBEdit;
    AmountReceivedDataSource: TDataSource;
    procedure SaveButtonClick(Sender: TObject);
  private
    procedure SetDataSet(const Value: TDataSet);
    procedure Save;
  public
    { Public declarations }
    property DataSet: TDataSet write SetDataSet;
  protected procedure LoadDFMValues; override; end;

var
  AmountReceivedForm: TAmountReceivedForm;

implementation

{$R *.dfm}

{ TAmountReceivedForm }

procedure TAmountReceivedForm.Save;
begin
  if AmountEdit.Text = '' then
    AmountReceivedDataSource.Dataset.FieldByName('AmountReceived').AsFloat := 0.00;

  AmountReceivedDataSource.DataSet.Post;
end;

procedure TAmountReceivedForm.SaveButtonClick(Sender: TObject);
begin
  Save;
  ModalResult := mrOK;
end;

procedure TAmountReceivedForm.SetDataSet(const Value: TDataSet);
begin
  AmountReceivedDataSource.DataSet := Value;
end;

procedure TAmountReceivedForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  SaveButton := TButton.Create('amountreceived.save.button');
  CancelButton := TButton.Create('amountreceived.cancel.button');
  AmountEdit := TDBEdit.Create('amountreceived.edit');
  AmountReceivedDataSource := TDataSource.Create(Self);

  SaveButton.BeforeLoadDFMValues;
  CancelButton.BeforeLoadDFMValues;
  AmountEdit.BeforeLoadDFMValues;
  AmountReceivedDataSource.BeforeLoadDFMValues;
  try
    Width := 413;
    Height := 143;
    Caption := 'AmountReceivedForm';
    ElementClassName := 'PopUpForm';
    SaveButton.SetParentComponent(Self);
    SaveButton.Name := 'SaveButton';
    SaveButton.Left := 176;
    SaveButton.Top := 96;
    SaveButton.Width := 96;
    SaveButton.Height := 25;
    SaveButton.Caption := 'Save';
    SaveButton.ChildOrder := 1;
    SaveButton.ElementClassName := 'btn btn-primary';
    SaveButton.HeightPercent := 100.000000000000000000;
    SaveButton.WidthPercent := 100.000000000000000000;
    SetEvent(SaveButton, Self, 'OnClick', 'SaveButtonClick');
    CancelButton.SetParentComponent(Self);
    CancelButton.Name := 'CancelButton';
    CancelButton.Left := 289;
    CancelButton.Top := 96;
    CancelButton.Width := 96;
    CancelButton.Height := 25;
    CancelButton.Caption := 'Cancel';
    CancelButton.ChildOrder := 1;
    CancelButton.ElementClassName := 'btn btn-primary';
    CancelButton.HeightPercent := 100.000000000000000000;
    CancelButton.ModalResult := 2;
    CancelButton.WidthPercent := 100.000000000000000000;
    AmountEdit.SetParentComponent(Self);
    AmountEdit.Name := 'AmountEdit';
    AmountEdit.Left := 208;
    AmountEdit.Top := 40;
    AmountEdit.Width := 161;
    AmountEdit.Height := 22;
    AmountEdit.ChildOrder := 2;
    AmountEdit.ElementClassName := 'form-control';
    AmountEdit.ElementFont := efCSS;
    AmountEdit.HeightPercent := 100.000000000000000000;
    AmountEdit.WidthPercent := 100.000000000000000000;
    AmountEdit.DataField := 'AmountReceived';
    AmountEdit.DataSource := AmountReceivedDataSource;
    AmountReceivedDataSource.SetParentComponent(Self);
    AmountReceivedDataSource.Name := 'AmountReceivedDataSource';
    AmountReceivedDataSource.Left := 80;
    AmountReceivedDataSource.Top := 16;
  finally
    SaveButton.AfterLoadDFMValues;
    CancelButton.AfterLoadDFMValues;
    AmountEdit.AfterLoadDFMValues;
    AmountReceivedDataSource.AfterLoadDFMValues;
  end;
end;

end.
